import React from 'react'
import {
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Stack,
    Button,
    useColorModeValue,
    VStack,
    Select,
} from '@chakra-ui/react';

export const CollectionForm = (
    { handleSudmit, handleInputChange, title, description, url, category, cover }
) => {
    return (
        <VStack
            onSubmit={handleSudmit}
            as="form"
            spacing={8}
            w="100%"
            bg={useColorModeValue('white', 'gray.700')}
            rounded="lg"
            boxShadow="lg"
            p={{ base: 5, sm: 10 }}
        >
            <VStack spacing={4} w="100%">
                <Stack w="100%" spacing={3} direction={{ base: 'column', md: 'row' }}>
                    <FormControl id="title">
                        <FormLabel>Title</FormLabel>
                        <Input
                            type="text"
                            placeholder="name of web"
                            rounded="md"
                            value={title}
                            name="title"
                            onChange={handleInputChange}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel htmlFor='country'>Collection Name</FormLabel>
                        <Select
                            id='category'
                            placeholder='Select collection name'
                            name="category"
                            value={category}
                            onChange={handleInputChange}
                            isRequired={true}
                        >
                            <option>Animations</option>
                            <option>CSS</option>
                            <option>Design</option>
                        </Select>
                    </FormControl>
                </Stack>
                <FormControl id="url">
                    <FormLabel>Url</FormLabel>
                    <Input
                        type="text"
                        placeholder="Url of web"
                        rounded="md"
                        value={url}
                        name="url"
                        onChange={handleInputChange}
                        isRequired={true}
                    />
                </FormControl>
                <FormControl id="cover">
                    <FormLabel>Cover Image</FormLabel>
                    <Input
                        type="text"
                        placeholder="Url of Image"
                        rounded="md"
                        value={cover}
                        name="cover"
                        onChange={handleInputChange}
                        isRequired={true}
                    />
                </FormControl>
                <FormControl id="description">
                    <FormLabel>Description</FormLabel>
                    <Textarea
                        size="lg"
                        placeholder="Description"
                        rounded="md"
                        name="description"
                        value={description}
                        onChange={handleInputChange}
                        isRequired={true}
                    />
                </FormControl>
            </VStack>
            <VStack w="100%">
                <Button
                    type='sudmit'
                    bg="green.300"
                    color="white"
                    _hover={{
                        bg: 'green.500'
                    }}
                    rounded="md"
                    w={{ base: '100%', md: 'max-content' }}
                >
                    Save
                </Button>
            </VStack>
        </VStack>
    )
}
